import { render, staticRenderFns } from "./bonusAndPromotions.vue?vue&type=template&id=6e4925e9&"
import script from "./bonusAndPromotions.vue?vue&type=script&lang=js&"
export * from "./bonusAndPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports